class MediaElementJS {
  constructor(element, options = {}) {
    this.element = element;
    this.options = options;
  }

  async run() {
    await import(/* webpackChunkName: 'mediaelement' */ 'mediaelement');
    return new MediaElement(this.element, this.options);
  }
}

export { MediaElementJS };
